import setupCanvas from './setup.xml?raw';
import problemCanvas from './problem.xml?raw';
import dotProductCanvas from './dot-product.xml?raw';
import queryKeyCanvas from './query-key.xml?raw';
import attentionWeightsCanvas from './attention-weights.xml?raw';
import valueOutputCanvas from './value-output.xml?raw';
import fullAttentionCanvas from './full-attention.xml?raw';

export type CanvasId =
  | 'setup'
  | 'problem'
  | 'dot-product'
  | 'query-key'
  | 'attention-weights'
  | 'value-output'
  | 'full-attention';

export const CANVAS_FILES: Record<CanvasId, string> = {
  setup: setupCanvas,
  problem: problemCanvas,
  'dot-product': dotProductCanvas,
  'query-key': queryKeyCanvas,
  'attention-weights': attentionWeightsCanvas,
  'value-output': valueOutputCanvas,
  'full-attention': fullAttentionCanvas,
};

export function injectCanvasWorld(worldElement: Element, canvasId: CanvasId): void {
  const xmlContent = CANVAS_FILES[canvasId];
  if (!xmlContent) {
    console.warn(`No canvas definition found for: ${canvasId}`);
    return;
  }

  const temp = document.createElement('div');
  temp.innerHTML = xmlContent.trim();

  for (const child of Array.from(temp.children)) {
    if (child.classList.contains('step')) {
      for (const seq of Array.from(child.children)) {
        worldElement.appendChild(seq);
      }
    } else {
      worldElement.appendChild(child);
    }
  }
}
